/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { useRef, useState, useEffect } from "react";

const ImageLoader = ({
  src,
  onLoad = null,
  onError = null,
  className = "",
  style = {},
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imgSrc, setImgSrc] = useState(src);
  const imgRef = useRef();

  const handleImageLoaded = () => {
    if (!imageLoaded) {
      setImageLoaded(true);
    }
    if (onLoad) onLoad();
  };

  const handleImageError = () => {
    setImgSrc(null);
    if (onError) onError();
  };

  useEffect(() => {
    const img = imgRef.current;
    if (img) {
      handleImageLoaded();
    }
  }, []);

  return (
    <>
      {imgSrc && (
        <img
          ref={imgRef}
          style={style}
          className={`${className} ${imageLoaded ? "img-fade-in" : ""}`}
          src={imgSrc}
          onLoad={handleImageLoaded}
          onError={handleImageError}
        />
      )}
      <style>{`
        img {
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }
        .img-fade-in {
          opacity: 1;
        }
      `}</style>
    </>
  );
};

export default ImageLoader;
